<template>
    <div class="wrap-content customer-section">
        <div class="filter-section row-min-space">
            <div class="row">
                <div class="col-md-12">
                    <h2>Customer Verification</h2>
                </div>
                <div class="col-md-12 filter-all-customers">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="row">
                                <div class="col-md-5">
                                    <base-search
                                        placeholder="Search"
                                        :clear="clearSearchValue"
                                        @keyword="getKeyword"
                                    ></base-search>
                                </div>
                                <div class="col-md-1">
                                    <b-form-group>
                                        <button
                                            class="btn btn-primary"
                                            type="submit"
                                            :class="
                                                loading && showPageLoader
                                                    ? 'disabled'
                                                    : ''
                                            "
                                            @click="apply"
                                        >
                                            <span class="btn-text">Apply</span>
                                            <span class="loader"></span>
                                        </button>
                                    </b-form-group>
                                </div>
                                <div class="col-md-3 filter-for-override" >
                                    <b-form-group
                                            id="input-group-4"

                                    >
                                        <b-form-select name="DataSegment" v-validate="{ required: true }" v-model="dataSegmentIdToFetch" :options="dataSegmentOptions"></b-form-select>
                                    </b-form-group>
                                </div>
                                <!--<div class="col-md-2">-->
                                    <!--<b-form-group>-->
                                        <!--<button-->
                                            <!--class="btn btn-primary"-->
                                            <!--type="button"-->
                                            <!--:class="-->
                                                <!--loading && showPageLoader-->
                                                    <!--? 'disabled'-->
                                                    <!--: ''-->
                                            <!--"-->
                                            <!--@click="clearSearch"-->
                                        <!--&gt;-->
                                            <!--<span class="btn-text"-->
                                                <!--&gt;Clear Search</span-->
                                            <!--&gt;-->
                                            <!--<span class="loader"></span>-->
                                        <!--</button>-->
                                    <!--</b-form-group>-->
                                <!--</div>-->
                                <div
                                    class="col-md-1 text-right export-file-btn"
                                >
                                    <b-form-group>
                                        <b-button
                                            type="button"
                                            variant="secondary"
                                            class="secondary-add-btn"
                                            @click="exportRecords"
                                        >
                                            <span class="btn-text">EXPORT</span>
                                        </b-button>
                                    </b-form-group>
                                </div>
                                <div
                                    class="col-md-2 text-right export-file-btn"
                                >
                                    <!-- Using modifiers -->
                                    <b-button
                                        v-b-toggle.collapse-2
                                        :style="{ backgroundColor: '#8B6F87' }"
                                        @click="onClickButtonDropdown"
                                        >Show Exports</b-button
                                    >
                                    <!-- Element to collapse -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <b-collapse id="collapse-2">
                    <b-table
                        v-if="data_downloads.length"
                        :items="data_downloads"
                        :fields="fields_downloads"
                        no-local-sorting
                        @sort-changed="sortingChanged"
                    >
                        <template slot="updatedAt" slot-scope="data">
                            <span>{{
                                data.item.updatedAt
                                    | moment('MMMM Do YYYY, h:mm:ss a')
                            }}</span>
                        </template>
                        <template slot="fileName" slot-scope="data">
                            <span>{{
                                data.item.exportDocumentTypeId ==
                                'Export All Customers'
                            }}</span>
                        </template>
                        <template slot="fileName" slot-scope="data">
                            <b-link
                                :href="`${APP_URL}files/export/${data.item.fileName}`"
                                >Download</b-link
                            >
                        </template>
                    </b-table>
                    <b-card v-else>
                        <h2>
                            There are no downloadable files ready for this data
                            segment, please request a file from the export
                            button
                        </h2>
                    </b-card>
                </b-collapse>
            </div>
        </div>

        <div
            :class="[
                'table-section',
                'table-min-width',
                {
                    'overflow-hidden': !data.length && !showPageLoader,
                },
            ]"
        >
            <b-table
                :items="data"
                :fields="fields"
                no-local-sorting
                @sort-changed="sortingChanged"
            >
                <template slot="id" slot-scope="data">
                    <label class="form-checkbox">
                        <input
                            v-model="selected"
                            type="checkbox"
                            :value="data.item._id"
                            class="customer_id"
                            name="customer_id[]"
                            @change="setCustomerID()"
                        />
                    </label>
                </template>
                <!-- Full Name -->
                <template slot="fullName" slot-scope="data">
                    {{ data.item.fullName }}
                </template>
                <!-- CNIC -->
                <template slot="nic" slot-scope="data">
                    {{ changeNIC(data.item.nic,data.item.passport) }}
                </template>
                <!-- Date of Birth -->
                <template slot="dob" slot-scope="data">
                    {{ data.item.dob | moment('MM-DD-YYYY') }}
                </template>
                <!-- Phone Number -->
                <template slot="phoneNumber" slot-scope="data">
                    {{ data.item.isdCode == '+92' ? '0' : data.item.isdCode
                    }}{{ data.item.phoneNumber }}
                </template>
                <!-- Company Name -->
                <template slot="company" slot-scope="data">
                    {{ data.item.company }}
                </template>
                <!-- Type Name -->
                <template slot="type" slot-scope="data">
                    {{ data.item.type ? data.item.type : 'individual' }}
                </template>
                <!-- Registration Date Name -->
                <template slot="createdAt" slot-scope="data">
                    {{ data.item.createdAt | moment('MM-DD-YYYY h:mm a') }}
                </template>
                <template
                        slot="status"
                        slot-scope="data"
                >
                    <base-status
                            :status-type="
                            data.item.status
                                ? data.item.status
                                : 'pending'
                        "
                    ></base-status>
                </template>
                <!-- status slot -->
                <template  v-if="APP_COUNTRY == 'Pakistan'" slot="nadraStatus" slot-scope="data">
                    <base-grid-status
                        :status-type="
                            data.item.customerVerificationStatus &&
                            data.item.customerVerificationStatus.nadra
                                ? data.item.customerVerificationStatus.nadra
                                : ''
                        "
                    >
                    </base-grid-status>
                </template>
                <!-- License Verification Status -->
                <template v-if="APP_COUNTRY == 'Pakistan'" slot="licenseStatus" slot-scope="data">
                    <base-grid-status
                        :status-type="
                            data.item.customerVerificationStatus &&
                            data.item.customerVerificationStatus.license
                                ? data.item.customerVerificationStatus.license
                                : ''
                        "
                    >
                    </base-grid-status>
                </template>
                <!-- criminalRecordVerification slot -->
                <template v-if="APP_COUNTRY == 'Pakistan'" slot="criminalRecordVerification" slot-scope="data">
                    <base-grid-status
                        :status-type="
                            data.item.customerVerificationStatus &&
                            data.item.customerVerificationStatus
                                .criminalRecordVerification
                                ? data.item.customerVerificationStatus
                                      .criminalRecordVerification
                                : ''
                        "
                    >
                    </base-grid-status>
                </template>

                <template v-if="APP_COUNTRY == 'Pakistan'" slot="degreeStatus" slot-scope="data">
                    <base-grid-status
                        :status-type="
                            data.item.customerVerificationStatus &&
                            data.item.customerVerificationStatus.degree
                                ? data.item.customerVerificationStatus.degree
                                : ''
                        "
                    >
                    </base-grid-status>
                </template>
                <template v-if="APP_COUNTRY == 'Pakistan'" slot="employmentStatus" slot-scope="data">
                    <base-grid-status
                        :status-type="
                            data.item.customerVerificationStatus &&
                            data.item.customerVerificationStatus.employment
                                ? data.item.customerVerificationStatus
                                      .employment
                                : ''
                        "
                    >
                    </base-grid-status>
                </template>

                <template v-if="APP_COUNTRY == 'Pakistan'"
                      slot="idenfoVerificationStatus" slot-scope="data">
                    <base-grid-status
                        :status-type="
                            data.item.customerVerificationStatus &&
                            data.item.customerVerificationStatus
                                .idenfoVerificationStatus
                                ? data.item.customerVerificationStatus
                                      .idenfoVerificationStatus
                                : ''
                        "
                    >
                    </base-grid-status>
                </template>

                <!-- Action Slot -->
                <template slot="action" slot-scope="data">
                    <div :class="['action-review', {}]" class="d-flex">
                        <!-- disabled:
                                    data.item.customerVerificationStatus
                                        .nadra != 'pending', -->
                        <base-action v-if="APP_COUNTRY == 'Pakistan'"
                            icon="icon-edit"
                            :label="
                                data.item.customerVerificationStatus.nadra !=
                                    'pending' &&
                                data.item.customerVerificationStatus
                                    .criminalRecordVerification != 'pending'
                                    ? 'Modify'
                                    : 'Verify'
                            "
                            @click="
                                selectedRecord(data.item)
                                $bvModal.show(
                                    'modify-customer-verification-popup'
                                )
                            "
                        ></base-action>
                        <base-action
                            v-if="user.roleName == 'Super Admin'"
                            icon="icon-edit"
                            label="Modify"
                            @click="
                                selectedRecord(data.item)
                                $bvModal.show('modify-customer-details-popup')
                            "
                        ></base-action>
                      
                        <base-action
                                icon="icon-export"
                                title="Download all documents"
                                @click="downloadAllFiles(data.item.documentInfo,data.item.fullName)"
                        ></base-action>

                        <base-action v-if="user.roleName=='Super Admin'"
                                icon="icon-setting"
                                title="Run manual KYC"
                                @click="openPopup('confirmation-popup',data.item._id,'Are you sure you want to start kyc process?','kyc')"
                        ></base-action>
                        <base-action v-if="user.roleName=='Super Admin'"
                                icon="icon-trash"
                                title="Delete record"
                                @click="openPopup('confirmation-popup',data.item._id,'Are you sure you want to delete this record?','deleteCustomer')"
                        ></base-action>
                    </div>
                </template>
            </b-table>

            <!-- When data is loading -->
            <base-table-spinner
                v-if="!data.length && showPageLoader"
            ></base-table-spinner>
            <!-- When record not found -->
            <base-no-record-found
                v-if="!data.length && !showPageLoader"
            ></base-no-record-found>
        </div>

        <base-records
            path="customers/customer-verification"
            :query="query"
            :reset="reset"
            :reload="reload"
            :show-pagination="true"
        ></base-records>
        <export-verification-process-popup
            :id="id"
            title="Export Customer's Data"
            :url="cancelUrl"
            :selected_users="selected"
            @emptyCheckBoxes="emptyValues($event)"
        ></export-verification-process-popup>
        <update-customer-verification-popup
            @statusUpdated="statusUpdated"
        ></update-customer-verification-popup>

        <update-customer-details-popup
            @statusUpdated="statusUpdated"
        ></update-customer-details-popup>

        <confirmation-popup
            :customer-id="customerId"
            :message="message"
            :type="type"
            @eventname="updateparent"
        ></confirmation-popup>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import exportVerificationProcessPopup from '@/components/popups/ExportVerificationProcessPopup.vue'
import UpdateCustomerVerificationPopup from '@/components/popups/UpdateCustomerVerificationPopup.vue'
import UpdateCustomerDetailsPopup from '@/components/popups/UpdateCustomerDetailsPopup.vue'
import ConfirmationPopup from '@/components/popups/ConfirmationPopup.vue'
import request from '@/utils/request'
import checkBoxListing from '@/components/CheckBoxListing.vue'
import axios from 'axios'
import Resource from '@/api/resource'
const apiResource = new Resource('configurations/get-all-dataSegments/')

export default {
    /*
        |--------------------------------------------------------------------------
        | Component > components
        |--------------------------------------------------------------------------
        */
    components: {
        exportVerificationProcessPopup,
        UpdateCustomerVerificationPopup,
        ConfirmationPopup,
        checkBoxListing,
        UpdateCustomerDetailsPopup,
    }, // End of Component > components

    /*
        |--------------------------------------------------------------------------
        | Component > props
        |--------------------------------------------------------------------------
        */
    props: {}, // End of Component > props

    /*
        |--------------------------------------------------------------------------
        | Component > data
        |--------------------------------------------------------------------------
        */
    data() {
        return {
            APP_URL: process.env.VUE_APP_API_URL,
            APP_COUNTRY: process.env.VUE_APP_COUNTRY,
            data_downloads: [],
            clearSearchValue: false,
            dataSegmentIdToFetch:'',
            dataSegmentOptions: [],
            toggle: false,
            fields_downloads: {
                updatedAt: {
                    label: 'Created At',
                    sortable: true,
                    tdAttr: {
                        dataname: 'updatedAt',
                    },
                },
                fileName: {
                    label: 'Download Link',
                    sortable: true,
                    tdAttr: {
                        dataname: 'fileName',
                    },
                },
            },
            selected: [],
            fields: {
                id: {
                    label: '#',
                    sortable: true,
                    tdAttr: {
                        dataname: 'ID',
                    },
                    tdClass: 'email-truncate',
                },
                idenfoId: {
                    label: 'Idenfo ID',
                    sortable: true,
                    tdAttr: {
                        dataname: 'Idenfo ID',
                    },
                    // tdClass: 'email-truncate',
                    tdClass: 'w-150px',
                },
                fullName: {
                    label: 'FULL NAME',
                    sortable: true,
                    tdAttr: {
                        dataname: 'Full Name',
                    },
                    // tdClass: 'email-truncate',
                    tdClass: 'w-150px',
                },
                fatherName: {
                    key: 'fatherName',
                    label: "FATHER's NAME",
                    sortable: true,
                    tdAttr: {
                        dataname: "Father's Name",
                    },
                    // tdClass: 'email-truncate',
                    tdClass: 'w-150px',
                },
                nic: {
                    label: 'ID/Passport',
                    sortable: true,
                    tdClass: 'w-150px',
                    tdAttr: {
                        dataname: 'NID',
                    },
                    // tdClass: 'email-truncate',
                },
                dob: {
                    label: 'DOB',
                    sortable: true,
                    tdClass: 'w-150px',
                    tdAttr: {
                        dataname: 'dob',
                    },
                    // tdClass: 'email-truncate',
                },
                address: {
                    label: 'Address',
                    sortable: true,
                    tdClass: 'w-150px',
                    tdAttr: {
                        dataname: 'address',
                    },
                    // tdClass: 'email-truncate',
                },
                company: {
                    label: 'Company',
                    sortable: true,
                    tdAttr: {
                        dataname: 'Company',
                    },
                    tdClass: 'email-truncate',
                },
                type: {
                    label: 'Category',
                    sortable: true,
                    tdAttr: {
                        dataname: 'Category',
                    },
                    tdClass: 'email-truncate',
                },
                status: {
                    label: 'Status',
                    sortable: true,
                    tdAttr: {
                        dataname: 'Status',
                    },
                    tdClass: 'email-truncate',
                },
                createdAt: {
                    label: 'Registration Date',
                    sortable: true,
                    tdAttr: {
                        dataname: 'Registration Date',
                    },
                    // tdClass: 'email-truncate',
                    tdClass: 'w-150px',
                },
                isDegreeOrEmployment:{
                    label: 'Degree / Employment',
                    sortable: true,
                    tdAttr: {
                        dataname: 'isDegreeOrEmployment',
                    },
                },
                nadraStatus: {
                    label: 'ID Check',
                    // sortable: true,
                    tdAttr: {
                        dataname: 'ID Check',
                    },
                    // tdClass: 'email-truncate',
                },
                // licenseStatus: {
                //     label: 'license Check',
                //     // sortable: true,
                //     tdAttr: {
                //         dataname: 'license Check',
                //     },
                //     // tdClass: 'email-truncate',
                // },
                criminalRecordVerification: {
                    label: 'CPLC Check',
                    // tdClass: 'w-150px',
                    tdAttr: {
                        dataname: 'CPLC Check',
                    },
                },
                degreeStatus: {
                    label: 'Degree Check',
                    // sortable: true,
                    tdAttr: {
                        dataname: 'Degree Check',
                    },
                    // tdClass: 'email-truncate',
                },
                employmentStatus: {
                    label: 'Employment Check',
                    // sortable: true,
                    tdAttr: {
                        dataname: 'Employment Check',
                    },
                    // tdClass: 'email-truncate',
                },
                idenfoVerificationStatus: {
                    label: 'Idenfo Verification',
                    // sortable: true,
                    tdAttr: {
                        dataname: 'Idenfo Verification',
                    },
                    // tdClass: 'email-truncate',
                },
                action: {
                    label: 'Actions',
                    tdClass: 'w-150px',
                    tdAttr: {
                        dataname: 'Actions',
                    },
                },
            },
            // filterList: [
            //     { text: 'All', value: null },
            //     { text: 'Pending Review', value: 'pending' },
            //     { text: 'Approved', value: 'approved' },
            //     { text: 'Rejected', value: 'rejected' },
            // ],
            query: {
                startAt: 1,
                keyword: '',
                perPage: 10,
                status: null,
                sortBy: 'createdAt',
                sortOrder: 'desc',
                dataSegmentId: 'skip',
            },
            reset: new Date().getTime(),
            reload: 0,
            id: null,
            customerId: null,
            message: null,
            type: null,
            cancelUrl: 'customers/cancel-export',
        }
    }, // End of Component > data

    /*
        |--------------------------------------------------------------------------
        | Component > computed
        |--------------------------------------------------------------------------
        */
    computed: {
        ...mapGetters([
            'data',
            'showPageLoader',
            'loading',
            'dataSegmentId',
            'hasScopes',
            'user',
        ]),
    }, // End of Component > computed
    /*
        |--------------------------------------------------------------------------
        | Component > watch
        |--------------------------------------------------------------------------
        */
    watch: {
        async dataSegmentIdToFetch(value){
            await this.apply()
            await this.getAllDataSegments()
        },
    }, // End of Component > methods

    /*
        |--------------------------------------------------------------------------
        | Component > mounted
        |--------------------------------------------------------------------------
        */
    mounted() {
        localStorage.setItem('goBackUrl', this.$route.name)
        let queryData = JSON.parse(localStorage.getItem('queryData'))
        if (queryData) {
            Object.assign(this.query, queryData)
            localStorage.removeItem('queryData')
        }
        this.getAllDataSegments()
        if (this.APP_COUNTRY != 'Pakistan') {
            delete this.fields['idenfoVerificationStatus']
            delete this.fields['isDegreeOrEmployment']
            delete this.fields['employmentStatus']
            delete this.fields['degreeStatus']
            delete this.fields['criminalRecordVerification']
            delete this.fields['nadraStatus']
        }
    }, // End of Component > watch

    /*
        |--------------------------------------------------------------------------
        | Component > methods
        |--------------------------------------------------------------------------
        */
    methods: {
        /**
         *
         * @return {void}
         */
        async getAllDataSegments(){
            const result = await apiResource.list();
            if(result && result.data){
                let tempDataSegments= result.data.data.map(el => ({value: el._id, text: el.title}));
                tempDataSegments= [{value: '', text: 'All DataSegments'} , ...tempDataSegments]
                this.dataSegmentOptions = tempDataSegments;

                let fetchSelected = result.data.data.map(el => {
                    if (this.dataSegmentIdToFetch!='' && el._id==this.dataSegmentIdToFetch) {
                        return el;
                    }
                    else if(this.dataSegmentIdToFetch=='' && el._id==this.dataSegmentId)
                    {
                        return el;
                    }
                });
                // fetchSelected = fetchSelected.filter(el => el !== undefined && el !== null);
                // this.currency = fetchSelected[0].currency

            }

        },
        statusUpdated() {
            this.reload++
        },
        getKeyword(val) {
            this.query.keyword = val
        }, // End of getKeyword() method
        async onClickButtonDropdown() {
            this.toggle = !this.toggle
            if (this.toggle) {
                console.log('Callin API')
                let { data } = await request.get(
                    `customers/getExportPdfInfo/${this.dataSegmentId}`,
                    null
                )
                this.data_downloads = data
                console.log(data)
            }
        },
        /**
         *
         * @return {void}
         */
        apply() {
            this.$store.commit('setLoading', true)
            this.reset = new Date().getTime()
            this.query.dataSegmentId = this.dataSegmentIdToFetch == '' ? 'skip' : this.dataSegmentIdToFetch
            // console.log('selected DS----',this.dataSegmentIdToFetch,this.query.dataSegmentId)

        }, // End of apply() method
        clearSearch() {
            this.getKeyword(null)
            this.clearSearchValue = !this.clearSearchValue
            this.reload++
            // this.reset = new Date().getTime()
        }, // End of clearSearch() method

        /**
         *
         * @return {void}
         */
        selectedRecord(record) {
            this.$store.commit('setItem', record)
        }, // End of selectedRecord() method

        /**
         *
         * @return {void}
         */
        sortingChanged(ctx) {
            // ctx.sortBy   ==> Field key for sorting by (or null for no sorting)
            this.query.sortBy = ctx.sortBy

            // ctx.sortDesc ==> true if sorting descending, false otherwise
            this.query.sortOrder = ctx.sortDesc ? 'desc' : 'asc'

            this.apply()
            this.$store.commit('setLoading', false)
        }, // End of sortingChanged() method

        /**
         *
         * @return {void}
         */
        async exportRecords() {
            try {
                // this.query.dataSegmentId = this.dataSegmentId

                // let { data } = await request.post('customers/export', null, {
                //     params: this.query,
                // })

                // //this.id = data.data.id
                // this.id = this.CryptoJS.AES.encrypt(
                //     JSON.stringify(data.data.id),
                //     process.env.VUE_APP_CRYPTO_SECERT_KEY
                // ).toString()
                this.$bvModal.show('export-verification-process-popup')
                // this.$toasted.show(data.message, {
                //     type: 'success',
                // })
            } catch (error) {
                //  console.log(error, 'error')
            }
        }, // End of exportRecords() method

        changeNIC(nic,passport) {
            let newNIC = ''
            if (nic && nic !== '' && nic !== null) {
                for (let i = 0; i < nic.length; i++) {
                    if (i == 5 || i == 12) {
                        newNIC += '-'
                    }
                    newNIC += nic[i]
                }
            }
            else
            {
                if(passport)
                {
                    newNIC = passport
                }
            }
            return newNIC
        },
        emptyValues(e) {
            console.log('im here')
            if (e == true) {
                this.selected = []
            }
        },
        setCustomerID() {
            console.log(this.selected)
        },

        async downloadAllFiles(documents, name) {
            console.log('docs----', documents)
            let filesArray = []
            let temp = {}
            if (documents.identity.fileName) {
                temp = {
                    src: 'customers/' + documents.identity.fileName,
                    title: documents.identity.originalFileName,
                }
                filesArray.push(temp)
            }
            if (documents.identityBack.fileName) {
                temp = {
                    src: 'customers/' + documents.identityBack.fileName,
                    title: documents.identityBack.originalFileName,
                }
                filesArray.push(temp)
            }
            if (documents.consentForm && documents.consentForm.fileName) {
                temp = {
                    src: 'customers/' + documents.consentForm.fileName,
                    title: documents.consentForm.originalFileName,
                }
                filesArray.push(temp)
            }
            if (documents.licenseFront && documents.licenseFront.fileName) {
                temp = {
                    src: 'customers/' + documents.licenseFront.fileName,
                    title: documents.licenseFront.originalFileName,
                }
                filesArray.push(temp)
            }
            if (documents.licenseBack && documents.licenseBack.fileName) {
                temp = {
                    src: 'customers/' + documents.licenseBack.fileName,
                    title: documents.licenseBack.originalFileName,
                }
                filesArray.push(temp)
            }
            let otherDocs = documents.otherDocuments
            if (otherDocs) {
                for (let i = 0; i < otherDocs.length; i++) {
                    temp = {
                        src: 'customer-documents/' + otherDocs[i].fileName,
                        title: otherDocs[i].originalFileName,
                    }
                    filesArray.push(temp)
                }
            }
            console.log(filesArray)
            if (filesArray.length > 0) {
                axios({
                    url: process.env.VUE_APP_FILE_SERVICE_URL + 'download',
                    method: 'POST',
                    data: { files: filesArray },
                    responseType: 'blob', // important
                })
                    .then((response) => {
                        console.log(response.data.url)
                        const url = window.URL.createObjectURL(
                            new Blob([response.data])
                        )
                        const link = document.createElement('a')
                        link.href = url
                        link.setAttribute('download', name + '_documents.zip') //or any other extension
                        document.body.appendChild(link)
                        link.click()
                    })
                    .catch(function (error) {
                        console.log(error)
                    })
            } else {
                this.$store.commit('setError', 'No Files found')
            }
        },
        async openPopup(popup, customerId, message, type) {
            this.customerId = customerId
            this.message = message
            this.type = type
            this.$bvModal.show(popup)
        },
        updateparent(variable) {
            this.reload++
        },
    }, // End of Component > mounted
} // End of export default
</script>
